import script from "./dashbEcosystem.vue?vue&type=script&setup=true&lang=js"
export * from "./dashbEcosystem.vue?vue&type=script&setup=true&lang=js"

import "./dashbEcosystem.vue?vue&type=style&index=0&id=05b6d590&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b6d590"]])

export default __exports__